//-------------------------------------------------------------------------------------------------- Imports
import { Col, Row } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import AssociatedContractCard from "./AssociatedContractCard";
import { ResponseSuscriptorDataHiredService } from "../../../types/common";
import { useEffect, useState } from "react";
import _ from "lodash";

//-------------------------------------------------------------------------------------------------- Interfaces
interface RenderHiredServicesCardsProps {
    servicesList?: ResponseSuscriptorDataHiredService[];
};

//-------------------------------------------------------------------------------------------------- Component
const RenderHiredServicesCards = (props: RenderHiredServicesCardsProps) => {
    const { servicesList } = props;
    const [services, setServices] =
        useState<Array<ResponseSuscriptorDataHiredService>>([]);
    const [servicesPremier, setServicesPremier] =
        useState<Array<ResponseSuscriptorDataHiredService>>([]);
    const [devices, setDevices] =
        useState<Array<ResponseSuscriptorDataHiredService>>([]);

    useEffect(() => {
        if (servicesList && !_.isEmpty(servicesList)) {
            let equiposArray = [] as ResponseSuscriptorDataHiredService[];

            setServices(servicesList.filter(srv => Number(srv.tipoServicio) !== 2));
            setServicesPremier(servicesList.filter(srv => Number(srv.tipoServicio) === 2));

            let modem = servicesList.find(
                srv => srv.desTipoEquipo === "CABLE MODEMS"
            );
            let tops = servicesList.find(srv => srv.desTipoEquipo === "SET TOPS");

            if (modem) {
                equiposArray.push(modem);
            }
            if (tops) {
                equiposArray.push(tops);
            }

            setDevices(equiposArray);
        }
    }, [servicesList]);

    return (
        <Row style={styles.cardsMainContainer}>
            <Col sm={24} xl={10}>
                <AssociatedContractCard title="SERVICIOS" services={services} />
            </Col>
            <Col md={24} lg={7} >
                <AssociatedContractCard title="PREMIER" services={servicesPremier} />
            </Col>
            <Col md={24} lg={7}>
                <AssociatedContractCard title="EQUIPOS" services={devices} />
            </Col>
        </Row>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardsMainContainer: {
        width: "100%",
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default RenderHiredServicesCards;
